import { useCallback, useSyncExternalStore } from 'react'

/**
 * Whether a CSS media query matches right now, kept current as it changes.
 *
 * Read from the viewport rather than the device: a tablet on its side, a phone
 * in landscape or a narrowed desktop window all get the layout that fits the
 * space they actually have.
 */
export const useMediaQuery = (query: string): boolean => {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query)

      list.addEventListener('change', onChange)

      return () => list.removeEventListener('change', onChange)
    },
    [query]
  )

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false
  )
}
